@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Vehicle Slider Drawer -->
<nz-drawer
  [nzWidth]="drawerWidth"
  [nzClosable]="true"
  [nzVisible]="vhclSldrVisible"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="vhclSldrVisible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicleForSlider) {
    <app-vehicle-slider
      [vechile]="selectedVehicleForSlider"
    ></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>

<!-- Driver Slider Drawer -->
<nz-drawer
  [nzWidth]="drawerWidth"
  [nzClosable]="true"
  [nzVisible]="driverSldrVisible"
  nzPlacement="right"
  nzTitle="Driver Profile"
  (nzOnClose)="driverSldrVisible = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedDriverForSlider) {
    <app-driver-slider [driver]="selectedDriverForSlider"></app-driver-slider>
    }
  </ng-container>
</nz-drawer>

<!-- Brand Header -->
<div
  class="relative mb-4 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between px-5 py-3 relative flex-wrap gap-2"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
          ></path>
          <path
            d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Vehicle & Driver Analytics
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center flex-wrap" style="gap: 8px">
      @if (fromUrbanDashboard) {
      <button
        (click)="goBackToDashboard()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <svg
          style="width: 14px; height: 14px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 17l-5-5m0 0l5-5m-5 5h12"
          ></path>
        </svg>
        Go Back
      </button>
      }
      <label style="font-size: 12px; font-weight: 600; color: #64748b"
        >Date:</label
      >
      <nz-date-picker
        [nzDisabledDate]="disabledDate"
        [nzFormat]="dateFormat"
        [(ngModel)]="slctdDt"
        (ngModelChange)="onChange($event)"
        style="border-radius: 6px; width: 150px"
      >
      </nz-date-picker>
    </div>
  </div>
</div>

<div class="mx-auto">
  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- Vehicle Overview Metrics                                -->
  <!-- ═══════════════════════════════════════════════════════ -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div>
    @for (d of tdyCoveredTrips; track d; let first = $first) { @if (first) {
    <!-- Overview Row: Vehicles | VMU Maintained | Distance & WH -->
    <div class="ds-overview-row ds-section">
      <!-- Vehicles Overview -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-blue">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
              ></path>
              <path
                d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
              ></path>
            </svg>
            <span class="ds-container-title">Vehicles Overview</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-3">
            <div class="ds-card ds-info" (click)="onVehicleCardClick()">
              <div class="ds-value">{{ tntLst.length || 0 }}</div>
              <div class="ds-label">ULBs</div>
            </div>
            <div class="ds-card ds-neutral" (click)="onVehicleCardClick()">
              <div class="ds-value">
                {{ (d.urban_ttl || 0) + (d.rural_ttl || 0) }}
              </div>
              <div class="ds-label">Total</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-teal"
                  [style.width.%]="100"
                ></div>
              </div>
            </div>
            <div class="ds-card ds-positive" (click)="onVehicleCardClick()">
              <div class="ds-value ds-teal">
                {{ overallOwnerCounts.own || 0 }}
              </div>
              <div class="ds-label">Own</div>
              <span class="ds-pct ds-pct-teal"
                >{{
                  (d.urban_ttl || 0) + (d.rural_ttl || 0) > 0
                    ? (((overallOwnerCounts.own || 0) /
                        ((d.urban_ttl || 0) + (d.rural_ttl || 0))) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-positive" (click)="onVehicleCardClick()">
              <div class="ds-value ds-teal">
                {{ overallOwnerCounts.contract || 0 }}
              </div>
              <div class="ds-label">Contract</div>
              <span class="ds-pct ds-pct-blue"
                >{{
                  (d.urban_ttl || 0) + (d.rural_ttl || 0) > 0
                    ? (((overallOwnerCounts.contract || 0) /
                        ((d.urban_ttl || 0) + (d.rural_ttl || 0))) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-warn" (click)="onVehicleCardClick()">
              <div class="ds-value ds-amber">
                {{ overallOwnerCounts.sac || 0 }}
              </div>
              <div class="ds-label">SAC</div>
              <span class="ds-pct ds-pct-amber"
                >{{
                  (d.urban_ttl || 0) + (d.rural_ttl || 0) > 0
                    ? (((overallOwnerCounts.sac || 0) /
                        ((d.urban_ttl || 0) + (d.rural_ttl || 0))) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- VMU Maintained -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-amber">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
              ></path>
            </svg>
            <span class="ds-container-title">VMU Maintained</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-3">
            <div class="ds-card ds-neutral" (click)="onVehicleCardClick()">
              <div class="ds-value">
                {{ vmuMaintainedData.cdma.total || 0 }}
              </div>
              <div class="ds-label">CDMA Total</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-green"
                  [style.width.%]="vmuMaintainedData.cdma.operatedPercent || 0"
                ></div>
              </div>
            </div>
            <div class="ds-card ds-positive" (click)="onVehicleCardClick()">
              <div class="ds-value ds-green">
                {{ vmuMaintainedData.cdma.operated || 0 }}
              </div>
              <div class="ds-label">CDMA Op</div>
              <span class="ds-pct ds-pct-green"
                >{{ vmuMaintainedData.cdma.operatedPercent || 0 }}%</span
              >
            </div>
            <div class="ds-card ds-negative" (click)="onVehicleCardClick()">
              <div class="ds-value ds-red">
                {{ vmuMaintainedData.cdma.notOperated || 0 }}
              </div>
              <div class="ds-label">CDMA Not Op</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (vmuMaintainedData.cdma.total || 0) > 0
                    ? (100 - (vmuMaintainedData.cdma.operatedPercent || 0)
                      | number : "1.0-1")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-neutral" (click)="onVehicleCardClick()">
              <div class="ds-value">{{ vmuMaintainedData.ulb.total || 0 }}</div>
              <div class="ds-label">ULB Total</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-green"
                  [style.width.%]="vmuMaintainedData.ulb.operatedPercent || 0"
                ></div>
              </div>
            </div>
            <div class="ds-card ds-positive" (click)="onVehicleCardClick()">
              <div class="ds-value ds-green">
                {{ vmuMaintainedData.ulb.operated || 0 }}
              </div>
              <div class="ds-label">ULB Op</div>
              <span class="ds-pct ds-pct-green"
                >{{ vmuMaintainedData.ulb.operatedPercent || 0 }}%</span
              >
            </div>
            <div class="ds-card ds-negative" (click)="onVehicleCardClick()">
              <div class="ds-value ds-red">
                {{ vmuMaintainedData.ulb.notOperated || 0 }}
              </div>
              <div class="ds-label">ULB Not Op</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (vmuMaintainedData.ulb.total || 0) > 0
                    ? (100 - (vmuMaintainedData.ulb.operatedPercent || 0)
                      | number : "1.0-1")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- Distance & Working Hours -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-purple">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span class="ds-container-title">Distance & Working Hours</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          @for (dist of ttlDstncCnt; track dist; let firstDist = $first) { @if
          (firstDist) {
          <div class="ds-equal-grid ds-grid-1" style="margin-bottom: 10px">
            <div class="ds-card ds-positive" (click)="onVehicleCardClick()">
              <div class="ds-value ds-green">
                {{ dist.urbn_tdydst_abv30 || 0 }}
              </div>
              <div class="ds-label">&gt;= 500m</div>
              <span class="ds-pct ds-pct-green"
                >{{
                  (dist.urbn_tdydst_abv30 || 0) +
                    (dist.urbn_tdydst_blw30 || 0) >
                  0
                    ? (((dist.urbn_tdydst_abv30 || 0) /
                        ((dist.urbn_tdydst_abv30 || 0) +
                          (dist.urbn_tdydst_blw30 || 0))) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-negative" (click)="onVehicleCardClick()">
              <div class="ds-value ds-red">
                {{ dist.urbn_tdydst_blw30 || 0 }}
              </div>
              <div class="ds-label">&lt; 500m</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (dist.urbn_tdydst_abv30 || 0) +
                    (dist.urbn_tdydst_blw30 || 0) >
                  0
                    ? (((dist.urbn_tdydst_blw30 || 0) /
                        ((dist.urbn_tdydst_abv30 || 0) +
                          (dist.urbn_tdydst_blw30 || 0))) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
          } }
          <div class="ds-equal-grid ds-grid-1">
            <div class="ds-card ds-positive" (click)="onVehicleCardClick()">
              <div class="ds-value ds-green">
                {{ d.abv_30_wrkd_tm_ct || 0 }}
              </div>
              <div class="ds-label">&gt;= 1hr</div>
              <span class="ds-pct ds-pct-green"
                >{{
                  (d.abv_30_wrkd_tm_ct || 0) + (d.blw_30_wrkd_tm_ct || 0) > 0
                    ? (((d.abv_30_wrkd_tm_ct || 0) /
                        ((d.abv_30_wrkd_tm_ct || 0) +
                          (d.blw_30_wrkd_tm_ct || 0))) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-negative" (click)="onVehicleCardClick()">
              <div class="ds-value ds-red">{{ d.blw_30_wrkd_tm_ct || 0 }}</div>
              <div class="ds-label">&lt; 1hr</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (d.abv_30_wrkd_tm_ct || 0) + (d.blw_30_wrkd_tm_ct || 0) > 0
                    ? (((d.blw_30_wrkd_tm_ct || 0) /
                        ((d.abv_30_wrkd_tm_ct || 0) +
                          (d.blw_30_wrkd_tm_ct || 0))) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ── Primary & Secondary ── -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5 ds-section">
      <!-- Primary -->
      <div class="ds-container ds-bg-primary">
        <div class="ds-container-header">
          <div class="flex items-center gap-2">
            <span class="ds-accent-bar ds-bar-blue"></span>
            <span class="ds-container-title">Primary</span>
            <span class="ds-container-badge"
              >{{ d.primary_ttl || 0 }} vehicles</span
            >
          </div>
          <div class="flex items-center gap-2">
            <span
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.3px;
              "
              >Operated %</span
            >
            <span
              style="
                display: inline-flex;
                align-items: center;
                padding: 2px 12px;
                border-radius: 20px;
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0.3px;
              "
              [style.background]="
                (d.primary_opper || 0) >= 50 ? '#ecfdf5' : '#fef2f2'
              "
              [style.color]="
                (d.primary_opper || 0) >= 50 ? '#059669' : '#dc2626'
              "
              [style.border]="
                (d.primary_opper || 0) >= 50
                  ? '1px solid #a7f3d0'
                  : '1px solid #fecaca'
              "
            >
              {{ d.primary_opper || 0 }}%
            </span>
          </div>
        </div>
        <div class="ds-container-body">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-5">
            <!-- Operation Status -->
            <div>
              <div class="ds-group-title">Operation Status</div>
              <div class="grid grid-cols-3 gap-2">
                <div
                  class="ds-card-sm ds-neutral"
                  (click)="onVehTypeClick('primary')"
                >
                  <div class="ds-value-sm">{{ d.primary_ttl || 0 }}</div>
                  <div class="ds-label-sm">Total</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  (click)="onVehTypeClick('primary')"
                >
                  <div class="ds-value-sm ds-green">
                    {{ d.primary_operated || 0 }}
                  </div>
                  <div class="ds-label-sm">Operated</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  (click)="onVehTypeClick('primary')"
                >
                  <div class="ds-value-sm ds-red">
                    {{ d.primary_notoperated || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Op.</div>
                </div>
              </div>
            </div>
            <!-- Owner Type -->
            <div>
              <div class="ds-group-title">Owner Type</div>
              <div class="grid grid-cols-3 gap-2">
                <div
                  class="ds-card-sm ds-neutral"
                  (click)="onVehTypeClick('primary')"
                >
                  <div class="ds-value-sm">
                    {{ primaryOwnerCounts.own || 0 }}
                  </div>
                  <div class="ds-label-sm">Own</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  (click)="onVehTypeClick('primary')"
                >
                  <div class="ds-value-sm ds-teal">
                    {{ primaryOwnerCounts.contract || 0 }}
                  </div>
                  <div class="ds-label-sm">Contract</div>
                </div>
                <div
                  class="ds-card-sm ds-warn"
                  (click)="onVehTypeClick('primary')"
                >
                  <div class="ds-value-sm ds-amber">
                    {{ primaryOwnerCounts.sac || 0 }}
                  </div>
                  <div class="ds-label-sm">SAC</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Secondary -->
      <div class="ds-container ds-bg-secondary">
        <div class="ds-container-header">
          <div class="flex items-center gap-2">
            <span class="ds-accent-bar ds-bar-amber"></span>
            <span class="ds-container-title">Secondary</span>
            <span class="ds-container-badge"
              >{{ d.secondary_ttl || 0 }} vehicles</span
            >
          </div>
          <div class="flex items-center gap-2">
            <span
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.3px;
              "
              >Operated %</span
            >
            <span
              style="
                display: inline-flex;
                align-items: center;
                padding: 2px 12px;
                border-radius: 20px;
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0.3px;
              "
              [style.background]="
                (d.secondary_opper || 0) >= 50 ? '#ecfdf5' : '#fef2f2'
              "
              [style.color]="
                (d.secondary_opper || 0) >= 50 ? '#059669' : '#dc2626'
              "
              [style.border]="
                (d.secondary_opper || 0) >= 50
                  ? '1px solid #a7f3d0'
                  : '1px solid #fecaca'
              "
            >
              {{ d.secondary_opper || 0 }}%
            </span>
          </div>
        </div>
        <div class="ds-container-body">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-5">
            <!-- Operation Status -->
            <div>
              <div class="ds-group-title">Operation Status</div>
              <div class="grid grid-cols-3 gap-2">
                <div
                  class="ds-card-sm ds-neutral"
                  (click)="onVehTypeClick('secondary')"
                >
                  <div class="ds-value-sm">{{ d.secondary_ttl || 0 }}</div>
                  <div class="ds-label-sm">Total</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  (click)="onVehTypeClick('secondary')"
                >
                  <div class="ds-value-sm ds-green">
                    {{ d.secondary_operated || 0 }}
                  </div>
                  <div class="ds-label-sm">Operated</div>
                </div>
                <div
                  class="ds-card-sm ds-negative"
                  (click)="onVehTypeClick('secondary')"
                >
                  <div class="ds-value-sm ds-red">
                    {{ d.secondary_notoperated || 0 }}
                  </div>
                  <div class="ds-label-sm">Not Op.</div>
                </div>
              </div>
            </div>
            <!-- Owner Type -->
            <div>
              <div class="ds-group-title">Owner Type</div>
              <div class="grid grid-cols-3 gap-2">
                <div
                  class="ds-card-sm ds-neutral"
                  (click)="onVehTypeClick('secondary')"
                >
                  <div class="ds-value-sm">
                    {{ secondaryOwnerCounts.own || 0 }}
                  </div>
                  <div class="ds-label-sm">Own</div>
                </div>
                <div
                  class="ds-card-sm ds-positive"
                  (click)="onVehTypeClick('secondary')"
                >
                  <div class="ds-value-sm ds-teal">
                    {{ secondaryOwnerCounts.contract || 0 }}
                  </div>
                  <div class="ds-label-sm">Contract</div>
                </div>
                <div
                  class="ds-card-sm ds-warn"
                  (click)="onVehTypeClick('secondary')"
                >
                  <div class="ds-value-sm ds-amber">
                    {{ secondaryOwnerCounts.sac || 0 }}
                  </div>
                  <div class="ds-label-sm">SAC</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    } }
  </div>
  }

  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- Driver Type Section                                     -->
  <!-- ═══════════════════════════════════════════════════════ -->
  <div class="ds-section">
    <div class="ds-driver-row">
      <!-- Driver Overview -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-teal">
          <div class="flex items-center gap-2">
            <svg
              style="width: 18px; height: 18px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <span class="ds-container-title">Driver Type</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div class="ds-equal-grid ds-grid-2">
            <div class="ds-card ds-neutral" (click)="onDriverCardClick()">
              <div class="ds-value">{{ driverTypeCounts.total || 0 }}</div>
              <div class="ds-label">Total</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-teal"
                  [style.width.%]="100"
                ></div>
              </div>
            </div>
            <div class="ds-card ds-info" (click)="onDriverCardClick()">
              <div class="ds-value" style="color: #1e40af">
                {{ driverTypeCounts.own || 0 }}
              </div>
              <div class="ds-label">OWN</div>
              <span class="ds-pct ds-pct-blue"
                >{{
                  (driverTypeCounts.total || 0) > 0
                    ? (((driverTypeCounts.own || 0) /
                        (driverTypeCounts.total || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-neutral" (click)="onDriverCardClick()">
              <div class="ds-value ds-muted">
                {{ driverTypeCounts.apcos || 0 }}
              </div>
              <div class="ds-label">APCOS</div>
              <span class="ds-pct ds-pct-slate"
                >{{
                  (driverTypeCounts.total || 0) > 0
                    ? (((driverTypeCounts.apcos || 0) /
                        (driverTypeCounts.total || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-warn" (click)="onDriverCardClick()">
              <div class="ds-value ds-amber">
                {{ driverTypeCounts.contract || 0 }}
              </div>
              <div class="ds-label">CONTRACT</div>
              <span class="ds-pct ds-pct-amber"
                >{{
                  (driverTypeCounts.total || 0) > 0
                    ? (((driverTypeCounts.contract || 0) /
                        (driverTypeCounts.total || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- OWN -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-blue">
          <div class="flex items-center gap-2">
            <svg
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <span class="ds-container-title">OWN</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div
            class="ds-equal-grid"
            style="grid-template-columns: repeat(3, 1fr)"
          >
            <div class="ds-card ds-neutral" (click)="onDriverCardClick()">
              <div class="ds-value">{{ driverTypeCounts.own || 0 }}</div>
              <div class="ds-label">Total</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-green"
                  [style.width.%]="
                    (driverTypeCounts.own || 0) > 0
                      ? ((driverTypeCounts.own_attended || 0) /
                          (driverTypeCounts.own || 1)) *
                        100
                      : 0
                  "
                ></div>
              </div>
            </div>
            <div class="ds-card ds-positive" (click)="onDriverCardClick()">
              <div class="ds-value ds-green">
                {{ driverTypeCounts.own_attended || 0 }}
              </div>
              <div class="ds-label">Attended</div>
              <span class="ds-pct ds-pct-green"
                >{{
                  (driverTypeCounts.own || 0) > 0
                    ? (((driverTypeCounts.own_attended || 0) /
                        (driverTypeCounts.own || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-negative" (click)="onDriverCardClick()">
              <div class="ds-value ds-red">
                {{ driverTypeCounts.own_not_attended || 0 }}
              </div>
              <div class="ds-label">Not Att.</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (driverTypeCounts.own || 0) > 0
                    ? (((driverTypeCounts.own_not_attended || 0) /
                        (driverTypeCounts.own || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- APCOS -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-slate">
          <div class="flex items-center gap-2">
            <svg
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <span class="ds-container-title">APCOS</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div
            class="ds-equal-grid"
            style="grid-template-columns: repeat(3, 1fr)"
          >
            <div class="ds-card ds-neutral" (click)="onDriverCardClick()">
              <div class="ds-value ds-muted">
                {{ driverTypeCounts.apcos || 0 }}
              </div>
              <div class="ds-label">Total</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-green"
                  [style.width.%]="
                    (driverTypeCounts.apcos || 0) > 0
                      ? ((driverTypeCounts.apcos_attended || 0) /
                          (driverTypeCounts.apcos || 1)) *
                        100
                      : 0
                  "
                ></div>
              </div>
            </div>
            <div class="ds-card ds-positive" (click)="onDriverCardClick()">
              <div class="ds-value ds-green">
                {{ driverTypeCounts.apcos_attended || 0 }}
              </div>
              <div class="ds-label">Attended</div>
              <span class="ds-pct ds-pct-green"
                >{{
                  (driverTypeCounts.apcos || 0) > 0
                    ? (((driverTypeCounts.apcos_attended || 0) /
                        (driverTypeCounts.apcos || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-negative" (click)="onDriverCardClick()">
              <div class="ds-value ds-red">
                {{ driverTypeCounts.apcos_not_attended || 0 }}
              </div>
              <div class="ds-label">Not Att.</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (driverTypeCounts.apcos || 0) > 0
                    ? (((driverTypeCounts.apcos_not_attended || 0) /
                        (driverTypeCounts.apcos || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- CONTRACT -->
      <div class="ds-container">
        <div class="ds-container-header ds-header-amber">
          <div class="flex items-center gap-2">
            <svg
              style="width: 16px; height: 16px"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <span class="ds-container-title">CONTRACT</span>
          </div>
        </div>
        <div class="ds-container-body ds-body-vcenter">
          <div
            class="ds-equal-grid"
            style="grid-template-columns: repeat(3, 1fr)"
          >
            <div class="ds-card ds-warn" (click)="onDriverCardClick()">
              <div class="ds-value ds-amber">
                {{ driverTypeCounts.contract || 0 }}
              </div>
              <div class="ds-label">Total</div>
              <div class="ds-mini-bar">
                <div
                  class="ds-mini-bar-fill fill-green"
                  [style.width.%]="
                    (driverTypeCounts.contract || 0) > 0
                      ? ((driverTypeCounts.contract_attended || 0) /
                          (driverTypeCounts.contract || 1)) *
                        100
                      : 0
                  "
                ></div>
              </div>
            </div>
            <div class="ds-card ds-positive" (click)="onDriverCardClick()">
              <div class="ds-value ds-green">
                {{ driverTypeCounts.contract_attended || 0 }}
              </div>
              <div class="ds-label">Attended</div>
              <span class="ds-pct ds-pct-green"
                >{{
                  (driverTypeCounts.contract || 0) > 0
                    ? (((driverTypeCounts.contract_attended || 0) /
                        (driverTypeCounts.contract || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
            <div class="ds-card ds-negative" (click)="onDriverCardClick()">
              <div class="ds-value ds-red">
                {{ driverTypeCounts.contract_not_attended || 0 }}
              </div>
              <div class="ds-label">Not Att.</div>
              <span class="ds-pct ds-pct-red"
                >{{
                  (driverTypeCounts.contract || 0) > 0
                    ? (((driverTypeCounts.contract_not_attended || 0) /
                        (driverTypeCounts.contract || 1)) *
                        100 | number : "1.0-0")
                    : 0
                }}%</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- VEHICLE TABLE SECTION                                   -->
  <!-- ═══════════════════════════════════════════════════════ -->
  <div
    class="bg-white rounded-lg mb-4 overflow-hidden ulb-grid-section"
    style="border: 1px solid #e5e7eb; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05)"
    id="vehicleTableSection"
  >
    <!-- Table Header -->
    <div
      class="flex items-center justify-between gap-2 px-4 py-2.5 flex-wrap"
      style="border-bottom: 1px solid #f1f5f9"
    >
      <div class="flex items-center gap-2">
        <div
          class="flex items-center justify-center"
          style="
            width: 28px;
            height: 28px;
            background: #f1f5f9;
            border-radius: 6px;
          "
        >
          <svg
            style="width: 14px; height: 14px; color: #475569"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
            ></path>
            <path
              d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
            ></path>
          </svg>
        </div>
        @if (!selectedVehicleUlb) {
        <span
          style="
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          "
          >ULB Wise Vehicle Details</span
        >
        } @if (selectedVehicleUlb) {
        <span
          style="
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          "
          >Vehicle Details - {{ selectedVehicleUlb.tnt_nm }}</span
        >
        }
      </div>
      <div class="flex items-center gap-2">
        <!-- Back button (detail view) -->
        @if (selectedVehicleUlb) {
        <button
          (click)="goBackToVehicleUlbs()"
          class="flex items-center gap-1 px-3 py-1 text-xs font-semibold rounded-md cursor-pointer"
          style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        >
          <svg
            style="width: 12px; height: 12px"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 17l-5-5m0 0l5-5m-5 5h12"
            ></path>
          </svg>
          Back to ULBs
        </button>
        }
        <!-- Filter pills (ULB list view) -->
        @if (!selectedVehicleUlb) {
        <button
          (click)="onVehTypeClick('all')"
          class="filter-pill"
          [class.active]="selectedVehType === 'all'"
        >
          All
        </button>
        <button
          (click)="onVehTypeClick('primary')"
          class="filter-pill"
          [class.active-blue]="selectedVehType === 'primary'"
        >
          Primary
        </button>
        <button
          (click)="onVehTypeClick('secondary')"
          class="filter-pill"
          [class.active-amber]="selectedVehType === 'secondary'"
        >
          Secondary
        </button>
        }
      </div>
    </div>

    <!-- ULB-Wise Vehicle Table (no ULB selected) -->
    @if (!selectedVehicleUlb) { @if (vehicleTableLdr) {
    <ds-loading></ds-loading>
    }
    <app-data-grid
      [totalItems]="gridTotals0"
      style="width: 100%; max-width: 100% !important"
      [dataSource]="ulbVehicleData"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="false"
      [groupPanel]="false"
      [columnChooser]="false"
      [allowExport]="true"
      exportFileName="ULB_Vehicle_Data"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        dataField="sno"
        caption="S.No"
        alignment="center"
        [width]="100"
      ></app-grid-column>
      <app-grid-column
        dataField="tnt_nm"
        caption="ULB Name"
        alignment="left"
        [width]="180"
        cellTemplate="ulbNameTemplate"
      ></app-grid-column>
      <app-grid-column caption="Vehicles Overview">
        <app-grid-column
          dataField="ttl_vhcls"
          caption="Total"
          alignment="center"
          [width]="100"
        ></app-grid-column>
        <app-grid-column caption="Distance Operated">
          <app-grid-column
            dataField="dist_vhcl_ttl"
            caption="Total"
            alignment="center"
            [width]="100"
          ></app-grid-column>
          <app-grid-column
            dataField="dist_operated"
            caption="Operated"
            alignment="center"
            [width]="100"
            cellTemplate="greenTemplate"
          ></app-grid-column>
          <app-grid-column
            dataField="dist_not_operated"
            caption="Not Operated"
            alignment="center"
            [width]="110"
            cellTemplate="redTemplate"
          ></app-grid-column>
        </app-grid-column>
        <app-grid-column caption="Working Hours Operated">
          <app-grid-column
            dataField="wh_vhcl_ttl"
            caption="Total"
            alignment="center"
            [width]="100"
          ></app-grid-column>
          <app-grid-column
            dataField="wh_operated"
            caption="Operated"
            alignment="center"
            [width]="100"
            cellTemplate="greenTemplate"
          ></app-grid-column>
          <app-grid-column
            dataField="wh_not_operated"
            caption="Not Operated"
            alignment="center"
            [width]="110"
            cellTemplate="redTemplate"
          ></app-grid-column>
        </app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Primary">
        <app-grid-column
          dataField="primary_ttl"
          caption="Total"
          alignment="center"
          [width]="100"
        ></app-grid-column>
        <app-grid-column caption="Distance Operated">
          <app-grid-column
            dataField="primary_dist_ttl"
            caption="Total"
            alignment="center"
            [width]="100"
          ></app-grid-column>
          <app-grid-column
            dataField="primary_dist_operated"
            caption="Operated"
            alignment="center"
            [width]="100"
            cellTemplate="greenTemplate"
          ></app-grid-column>
          <app-grid-column
            dataField="primary_dist_not_operated"
            caption="Not Operated"
            alignment="center"
            [width]="110"
            cellTemplate="redTemplate"
          ></app-grid-column>
        </app-grid-column>
        <app-grid-column caption="Working Hours Operated">
          <app-grid-column
            dataField="primary_wh_ttl"
            caption="Total"
            alignment="center"
            [width]="100"
          ></app-grid-column>
          <app-grid-column
            dataField="primary_wh_operated"
            caption="Operated"
            alignment="center"
            [width]="100"
            cellTemplate="greenTemplate"
          ></app-grid-column>
          <app-grid-column
            dataField="primary_wh_not_operated"
            caption="Not Operated"
            alignment="center"
            [width]="110"
            cellTemplate="redTemplate"
          ></app-grid-column>
        </app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Secondary">
        <app-grid-column
          dataField="secondary_ttl"
          caption="Total"
          alignment="center"
          [width]="100"
        ></app-grid-column>
        <app-grid-column caption="Distance Operated">
          <app-grid-column
            dataField="secondary_dist_ttl"
            caption="Total"
            alignment="center"
            [width]="100"
          ></app-grid-column>
          <app-grid-column
            dataField="secondary_dist_operated"
            caption="Operated"
            alignment="center"
            [width]="100"
            cellTemplate="greenTemplate"
          ></app-grid-column>
          <app-grid-column
            dataField="secondary_dist_not_operated"
            caption="Not Operated"
            alignment="center"
            [width]="110"
            cellTemplate="redTemplate"
          ></app-grid-column>
        </app-grid-column>
        <app-grid-column caption="Working Hours Operated">
          <app-grid-column
            dataField="secondary_wh_ttl"
            caption="Total"
            alignment="center"
            [width]="100"
          ></app-grid-column>
          <app-grid-column
            dataField="secondary_wh_operated"
            caption="Operated"
            alignment="center"
            [width]="100"
            cellTemplate="greenTemplate"
          ></app-grid-column>
          <app-grid-column
            dataField="secondary_wh_not_operated"
            caption="Not Operated"
            alignment="center"
            [width]="110"
            cellTemplate="redTemplate"
          ></app-grid-column>
        </app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Owner Type">
        <app-grid-column
          dataField="own_ct"
          caption="Own"
          alignment="center"
          [width]="150"
        ></app-grid-column>
        <app-grid-column
          dataField="contract_ct"
          caption="Contract"
          alignment="center"
          [width]="150"
        ></app-grid-column>
        <app-grid-column
          dataField="sac_ct"
          caption="SAC"
          alignment="center"
          [width]="150"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Distance">
        <app-grid-column
          dataField="dist_abv_500m"
          caption=">= 500m"
          alignment="center"
          [width]="150"
          cellTemplate="greenTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="dist_blw_500m"
          caption="< 500m"
          alignment="center"
          [width]="150"
          cellTemplate="redTemplate"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="Working Hours">
        <app-grid-column
          dataField="wh_abv"
          caption=">= 1hr"
          alignment="center"
          [width]="150"
          cellTemplate="greenTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="wh_blw"
          caption="< 1hr"
          alignment="center"
          [width]="150"
          cellTemplate="redTemplate"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="VMU - CDMA">
        <app-grid-column
          dataField="cdma_total"
          caption="Total"
          alignment="center"
          [width]="150"
        ></app-grid-column>
        <app-grid-column
          dataField="cdma_operated"
          caption="Operated"
          alignment="center"
          [width]="150"
          cellTemplate="greenTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="cdma_not_operated"
          caption="Not Operated"
          alignment="center"
          [width]="150"
          cellTemplate="redTemplate"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="VMU - ULB">
        <app-grid-column
          dataField="ulb_dev_total"
          caption="Total"
          alignment="center"
          [width]="150"
        ></app-grid-column>
        <app-grid-column
          dataField="ulb_dev_operated"
          caption="Operated"
          alignment="center"
          [width]="150"
          cellTemplate="greenTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="ulb_dev_not_operated"
          caption="Not Operated"
          alignment="center"
          [width]="150"
          cellTemplate="redTemplate"
        ></app-grid-column>
      </app-grid-column>
      <ng-template appGridCell="ulbNameTemplate" let-data="cell"
        ><div>
          <a class="ulb-link" (click)="onVehicleUlbClick(data.data)">{{
            data.data.tnt_nm
          }}</a>
        </div></ng-template
      >
      <ng-template appGridCell="greenTemplate" let-data="cell"
        ><div>
          <span class="font-semibold text-emerald-600">{{
            data.value || 0
          }}</span>
        </div></ng-template
      >
      <ng-template appGridCell="redTemplate" let-data="cell"
        ><div>
          <span class="font-semibold text-red-500">{{ data.value || 0 }}</span>
        </div></ng-template
      >
      <ng-template appGridCell="opRateTemplate" let-data="cell"
        ><div>
          <span
            [class]="
              (data.value || 0) >= 50
                ? 'font-semibold text-emerald-600'
                : 'font-semibold text-red-500'
            "
            >{{ data.value || 0 }}%</span
          >
        </div></ng-template
      >
    </app-data-grid>
    @if (!vehicleTableLdr && ulbVehicleData.length === 0) {
    <div class="empty-state">
      <i nz-icon nzType="inbox" nzTheme="outline"></i>
      <p>No vehicle data available</p>
    </div>
    } }

    <!-- Vehicle Detail Table (ULB selected) -->
    @if (selectedVehicleUlb) { @if (vehicleDetailLdr) {
    <ds-loading></ds-loading>
    }
    <app-data-grid
      style="width: 100%; max-width: 100% !important"
      [dataSource]="vehicleDetailList"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="false"
      [groupPanel]="false"
      [columnChooser]="false"
      [allowExport]="true"
      [exportFileName]="'Vehicle_Detail_' + selectedVehicleUlb.tnt_nm"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        dataField="sno"
        caption="S.No"
        alignment="center"
        [width]="55"
      ></app-grid-column>
      <app-grid-column
        dataField="asrt_nm"
        caption="Vehicle Name"
        alignment="left"
        [width]="200"
        cellTemplate="vdVehicleNameTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="asrt_ctgry_nm"
        caption="Vehicle Category"
        alignment="left"
        [width]="200"
      ></app-grid-column>
      <app-grid-column
        dataField="trp_type"
        caption="Type"
        alignment="center"
        [width]="150"
        cellTemplate="vdTrpTypeTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="owner_type"
        caption="Owner"
        alignment="center"
        [width]="120"
      ></app-grid-column>
      <app-grid-column
        dataField="distance_km"
        caption="Distance (km)"
        alignment="center"
        [width]="150"
      ></app-grid-column>
      <app-grid-column
        dataField="operated"
        caption="Operated"
        alignment="center"
        [width]="150"
        cellTemplate="vdOperatedTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="wrkd_tm_fmt"
        caption="Working Time"
        alignment="center"
        [width]="150"
      ></app-grid-column>
      <app-grid-column
        dataField="wh_above_1hr"
        caption="WH >= 1hr"
        alignment="center"
        [width]="150"
        cellTemplate="vdWhTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="vmu_type"
        caption="VMU Type"
        alignment="center"
        [width]="150"
        cellTemplate="vdVmuTypeTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="vmu_operated"
        caption="Vehicle Operated"
        alignment="center"
        [width]="150"
        cellTemplate="vdVmuOpTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="asrt_sts_nm"
        caption="Vehicle Status"
        alignment="center"
        [width]="150"
      ></app-grid-column>
      <ng-template appGridCell="vdVehicleNameTemplate" let-d="cell"
        ><div>
          <a
            class="ulb-link"
            [class.active-row-highlight]="
              selectedVehicleForSlider?.asrt_id === d.data.asrt_id
            "
            (click)="onVehicleNameClick(d.data)"
            >{{ d.value }}</a
          >
        </div></ng-template
      >
      <ng-template appGridCell="vdTrpTypeTemplate" let-d="cell"
        ><div>
          <span
            [class]="
              d.value === 'Primary'
                ? 'text-blue-600 font-semibold'
                : 'text-amber-600 font-semibold'
            "
            >{{ d.value }}</span
          >
        </div></ng-template
      >
      <ng-template appGridCell="vdOperatedTemplate" let-d="cell"
        ><div>
          <span
            [class]="
              d.value === 1
                ? 'text-emerald-600 font-semibold'
                : 'text-red-500 font-semibold'
            "
            >{{ d.value === 1 ? "Yes" : "No" }}</span
          >
        </div></ng-template
      >
      <ng-template appGridCell="vdWhTemplate" let-d="cell"
        ><div>
          <span
            [class]="
              d.value === 1
                ? 'text-emerald-600 font-semibold'
                : 'text-red-500 font-semibold'
            "
            >{{ d.value === 1 ? "Yes" : "No" }}</span
          >
        </div></ng-template
      >
      <ng-template appGridCell="vdVmuTypeTemplate" let-d="cell"
        ><div>
          <span
            [class]="
              d.value === 'CDMA'
                ? 'text-indigo-600 font-semibold'
                : 'text-teal-600 font-semibold'
            "
            >{{ d.value }}</span
          >
        </div></ng-template
      >
      <ng-template appGridCell="vdVmuOpTemplate" let-d="cell"
        ><div>
          <span
            [class]="
              d.value === 1
                ? 'text-emerald-600 font-semibold'
                : 'text-red-500 font-semibold'
            "
            >{{ d.value === 1 ? "Operated" : "Not Operated" }}</span
          >
        </div></ng-template
      >
    </app-data-grid>
    @if (!vehicleDetailLdr && vehicleDetailList.length === 0) {
    <div class="empty-state">
      <i nz-icon nzType="inbox" nzTheme="outline"></i>
      <p>No vehicle details available for {{ selectedVehicleUlb.tnt_nm }}</p>
    </div>
    } }
  </div>

  <!-- ═══════════════════════════════════════════════════════ -->
  <!-- DRIVER TABLE SECTION                                    -->
  <!-- ═══════════════════════════════════════════════════════ -->
  <div
    class="bg-white rounded-lg mb-4 overflow-hidden driver-grid-section"
    style="border: 1px solid #e5e7eb; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05)"
    id="driverTableSection"
  >
    <!-- Table Header -->
    <div
      class="flex items-center justify-between gap-2 px-4 py-2.5 flex-wrap"
      style="border-bottom: 1px solid #f1f5f9"
    >
      <div class="flex items-center gap-2">
        <div
          class="flex items-center justify-center"
          style="
            width: 28px;
            height: 28px;
            background: #f1f5f9;
            border-radius: 6px;
          "
        >
          <svg
            style="width: 14px; height: 14px; color: #475569"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
        </div>
        @if (!selectedDriverUlb) {
        <span
          style="
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          "
          >ULB Wise Driver Details</span
        >
        } @if (selectedDriverUlb) {
        <span
          style="
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
          "
          >Driver Details - {{ selectedDriverUlb.tnt_nm }}</span
        >
        }
      </div>
      <div class="flex items-center gap-2">
        @if (selectedDriverUlb) {
        <button
          (click)="goBackToDriverUlbs()"
          class="flex items-center gap-1 px-3 py-1 text-xs font-semibold rounded-md cursor-pointer"
          style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        >
          <svg
            style="width: 12px; height: 12px"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 17l-5-5m0 0l5-5m-5 5h12"
            ></path>
          </svg>
          Back to ULBs
        </button>
        }
      </div>
    </div>

    <!-- ULB-Wise Driver Table (no ULB selected) -->
    @if (!selectedDriverUlb) { @if (driverTableLdr) {
    <ds-loading></ds-loading>
    }
    <app-data-grid
      [totalItems]="gridTotals2"
      style="width: 100%; max-width: 100% !important"
      [dataSource]="ulbDriverData"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="false"
      [groupPanel]="false"
      [columnChooser]="false"
      [allowExport]="true"
      exportFileName="ULB_Driver_Data"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        dataField="sno"
        caption="S.No"
        alignment="center"
        [width]="100"
      ></app-grid-column>
      <app-grid-column
        dataField="tnt_nm"
        caption="ULB Name"
        alignment="left"
        [width]="180"
        cellTemplate="drvUlbNameTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="total_drivers"
        caption="Total Drivers"
        alignment="center"
        [width]="150"
      ></app-grid-column>
      <app-grid-column caption="OWN">
        <app-grid-column
          dataField="own"
          caption="Total"
          alignment="center"
          [width]="120"
        ></app-grid-column>
        <app-grid-column
          dataField="own_attended"
          caption="Attended"
          alignment="center"
          [width]="120"
          cellTemplate="drvGreenTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="own_not_attended"
          caption="Not Att"
          alignment="center"
          [width]="120"
          cellTemplate="drvRedTemplate"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="APCOS">
        <app-grid-column
          dataField="apcos"
          caption="Total"
          alignment="center"
          [width]="120"
        ></app-grid-column>
        <app-grid-column
          dataField="apcos_attended"
          caption="Attended"
          alignment="center"
          [width]="120"
          cellTemplate="drvGreenTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="apcos_not_attended"
          caption="Not Att"
          alignment="center"
          [width]="120"
          cellTemplate="drvRedTemplate"
        ></app-grid-column>
      </app-grid-column>
      <app-grid-column caption="CONTRACT">
        <app-grid-column
          dataField="contract"
          caption="Total"
          alignment="center"
          [width]="120"
        ></app-grid-column>
        <app-grid-column
          dataField="contract_attended"
          caption="Attended"
          alignment="center"
          [width]="120"
          cellTemplate="drvGreenTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="contract_not_attended"
          caption="Not Att"
          alignment="center"
          [width]="120"
          cellTemplate="drvRedTemplate"
        ></app-grid-column>
      </app-grid-column>
      <ng-template appGridCell="drvUlbNameTemplate" let-data="cell"
        ><div>
          <a class="ulb-link" (click)="onDriverUlbClick(data.data)">{{
            data.data.tnt_nm
          }}</a>
        </div></ng-template
      >
      <ng-template appGridCell="drvGreenTemplate" let-data="cell"
        ><div>
          <span class="font-semibold text-emerald-600">{{
            data.value || 0
          }}</span>
        </div></ng-template
      >
      <ng-template appGridCell="drvRedTemplate" let-data="cell"
        ><div>
          <span class="font-semibold text-red-500">{{ data.value || 0 }}</span>
        </div></ng-template
      >
    </app-data-grid>
    @if (!driverTableLdr && ulbDriverData.length === 0) {
    <div class="empty-state">
      <i nz-icon nzType="inbox" nzTheme="outline"></i>
      <p>No driver data available</p>
    </div>
    } }

    <!-- Driver Detail Table (ULB selected) -->
    @if (selectedDriverUlb) { @if (driverDetailLdr) {
    <ds-loading></ds-loading>
    }
    <app-data-grid
      style="width: 100%; max-width: 100% !important"
      [dataSource]="driverDetailList"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="false"
      [groupPanel]="false"
      [columnChooser]="false"
      [allowExport]="true"
      [exportFileName]="'Driver_Detail_' + selectedDriverUlb.tnt_nm"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <app-grid-column
        dataField="sno"
        caption="S.No"
        alignment="center"
        [width]="100"
      ></app-grid-column>
      <app-grid-column
        dataField="crw_nm"
        caption="Driver Name"
        alignment="left"
        [width]="200"
        cellTemplate="ddDriverNameTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="crw_ph"
        caption="Phone"
        alignment="center"
        [width]="130"
      ></app-grid-column>
      <app-grid-column
        dataField="driver_type"
        caption="Type"
        alignment="center"
        [width]="300"
        cellTemplate="ddTypeTemplate"
      ></app-grid-column>
      <app-grid-column
        dataField="attended"
        caption="Attended"
        alignment="center"
        [width]="300"
        cellTemplate="ddAttendedTemplate"
      ></app-grid-column>
      <ng-template appGridCell="ddDriverNameTemplate" let-d="cell"
        ><div>
          <a
            class="ulb-link"
            [class.active-row-highlight]="
              selectedDriverForSlider?.crw_id === d.data.crw_id
            "
            (click)="onDriverNameClick(d.data)"
            >{{ d.value }}</a
          >
        </div></ng-template
      >
      <ng-template appGridCell="ddTypeTemplate" let-d="cell"
        ><div>
          <span
            [class]="
              d.value === 'OWN'
                ? 'text-blue-600 font-semibold'
                : d.value === 'APCOS'
                ? 'text-slate-600 font-semibold'
                : 'text-amber-600 font-semibold'
            "
            >{{ d.value }}</span
          >
        </div></ng-template
      >
      <ng-template appGridCell="ddAttendedTemplate" let-d="cell"
        ><div>
          <span
            [class]="
              d.value === 1
                ? 'text-emerald-600 font-semibold'
                : 'text-red-500 font-semibold'
            "
            >{{ d.value === 1 ? "Yes" : "No" }}</span
          >
        </div></ng-template
      >
    </app-data-grid>
    @if (!driverDetailLdr && driverDetailList.length === 0) {
    <div class="empty-state">
      <i nz-icon nzType="inbox" nzTheme="outline"></i>
      <p>No driver details available for {{ selectedDriverUlb.tnt_nm }}</p>
    </div>
    } }
  </div>
</div>
